import React, { memo } from "react";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import {
	getMailboxFolderItemByApiFolder,
	getMailboxMessageDetailPath,
	getMessageDate,
	getMessageFromParty,
	getMessageId,
} from "src/modules/mailer/helpers";

const formatBannerDate = (value) => {
	if (!value) {
		return "";
	}

	const date = new Date(value);

	if (Number.isNaN(date.getTime())) {
		return String(value);
	}

	return date.toLocaleDateString(undefined, {
		month: "short",
		day: "numeric",
		year: "numeric",
	});
};

const getReportMailboxMessage = (report) => {
	const message = report?.mailbox_message ?? report?.mailboxMessage;

	if (!message || typeof message !== "object" || Array.isArray(message)) {
		return null;
	}

	return message;
};

const RelatedMailboxMessage = ({ t, report, variant = "request" }) => {
	const message = getReportMailboxMessage(report);

	if (!message) {
		return null;
	}

	const messageId = getMessageId(message);
	const party = getMessageFromParty(message);
	const sender =
		party.display ||
		message.from_address ||
		message.fromAddress ||
		t("Unknown sender");
	const receivedDate = formatBannerDate(getMessageDate(message));
	const folderItem = getMailboxFolderItemByApiFolder(
		message.folder || message.imap_folder || message.imapFolder
	);
	const detailPath = messageId
		? {
				pathname: getMailboxMessageDetailPath(messageId),
				state: {
					mailboxFolderPath: folderItem?.path,
				},
		  }
		: null;
	const leadKey =
		variant === "incident"
			? "This incident was automatically created from an email sent by"
			: "This request was automatically created from an email sent by";

	return (
		<div className="mailbox-created-from-email">
			<div
				className="mailbox-created-from-email__icon"
				aria-hidden="true"
			>
				<i className="mdi mdi-email" />
			</div>

			<div className="mailbox-created-from-email__body">
				<div className="mailbox-created-from-email__title">
					{t("Created from email")}
				</div>
				<p className="mailbox-created-from-email__description">
					{t(leadKey)}
					{" "}
					<strong>{sender}</strong>
					{receivedDate ? ` ${t("on {{date}}", { date: receivedDate })}` : ""}
					{"."}
				</p>
			</div>

			{detailPath ? (
				<Link
					to={detailPath}
					className="mailbox-created-from-email__link"
				>
					{t("View original email")}
					<i className="ri-arrow-right-line" aria-hidden="true" />
				</Link>
			) : null}
		</div>
	);
};

export default withNamespaces()(memo(RelatedMailboxMessage));
